const marka = { t: 'Marka', name: 'marka', hint: { url: '/make/car', cache: 'car-make', exact: true, isDepFor: ['model','generacja'] }}
export default marka